import React, {useRef, useState, useEffect} from 'react';

import StepSectionHeader from "./StepSectionHeader";


function StepSection({title, firstSection, children}) {
  const stepBodyEl = useRef(null);
  const [sectionState, setSectionState] = useState(false);
  const toggleSection = () => {
      setSectionState(!sectionState);
  };

  useEffect(() => {
   if (firstSection) {
     setSectionState(true);
   }
  }, [firstSection, setSectionState]);


  return (
    <div className="ct-step__section">
      <StepSectionHeader
        title={title}
        sectionState={sectionState}
        toggleSection={toggleSection}
      />
      <div className={`ct-step__section-body ${sectionState ? 'ct-step__section-body-opened' : null}`} ref={stepBodyEl}>
          {children}
      </div>
    </div>
  );
}

export default StepSection;
